import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { ANNUAL_REPORT_API } from "./apiRoutes";

const mutateUpdateAnnualReporting = async ({
  id,
  data,
}: {
  id: string;
  data: FieldValues;
}) => {
  return await axiosAuth.put(`${ANNUAL_REPORT_API}/${id}`, data);
};

const useUpdateAnnualReportingMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateAnnualReporting,
    ...queryParams,
  });

export default useUpdateAnnualReportingMutation;
